export enum OffersMethods {
  GET_OFFER = 'get_offer' as any
}
